import React from 'react';
import {IoMdCheckmarkCircle, IoMdCloseCircle} from 'react-icons/io';


export default function StatusIcon({status, size = 16}) {
    const isTrue = status === 1 || status === true;
    return (
        <div className="tw-flex tw-justify-center tw-items-center">
            {isTrue ? (
                <IoMdCheckmarkCircle style={{color: '#4CAF50', fontSize: size}} />
            ) : (
                <IoMdCloseCircle style={{color: '#F44336', fontSize: size}} />
            )}
        </div>
    );
}
